import { uint16, uint32 } from '../../utils';
import { getProtocol } from '../constant';
import {
  app_id,
  CONDITION,
  FILE,
  IMG,
  TRANSLATION,
  WIDGET
} from '../dataSource';
import {
  WIDGET_PRE_LENGTH,
  genId,
  genRecord,
  getRelateRecordUid,
  makeFillUpOfFour
} from './utils';

export function genWidgetData(
  widget: Ast,
  curDataAddress: number,
  recordList: any[]
): { originData: any; originRecord: any } {
  const type = WIDGET;
  const {
    name,
    preview,
    bg,
    bgColor,
    jumpApp,
    icon,
    editBox,
    groupType,
    widgetName,
    flex_direction,
    align_items,
    justify_content,
    align_content,
    gap,
    w,
    h,
    args,
    condition,
    minClickZone
  } = widget.attrsMap;
  // 计算内部item元素
  const { children } = widget;
  const posTable: number[][] = [];
  const refTable: string[] = [];
  const animationTable: string[] = [];
  children.forEach((item: any) => {
    const { x, y, ref, animation = undefined } = item.attrsMap;
    if (x && y) posTable.push([x, y]);
    else posTable.push([0, 0]);
    refTable.push(ref);
    animationTable.push(animation);
  });
  const widgetJsUid = getRelateRecordUid(args, recordList, FILE);
  const previewRelateUid = getRelateRecordUid(preview, recordList, IMG);
  const bgRelateUid = getRelateRecordUid(bg, recordList, IMG);
  const iconRelateUid = getRelateRecordUid(icon, recordList, IMG);
  const editBoxRelateUid = getRelateRecordUid(editBox, recordList, IMG);
  const translateWidgetNameUid = getRelateRecordUid(
    widgetName,
    recordList,
    TRANSLATION
  );
  const translateGroupTypeUid = getRelateRecordUid(
    groupType,
    recordList,
    TRANSLATION
  );

  const conditionUid = condition
    ? [uint32(2), getRelateRecordUid(condition, recordList, CONDITION)]
    : [];
  const uidTable: Buffer[] = [];
  const dataTable = [];
  if (refTable.length > 0) {
    refTable.forEach((ref: string) => {
      const widgetItemResourceUid = getRelateRecordUid(ref, recordList);
      widgetItemResourceUid && uidTable.push(widgetItemResourceUid);
    });
  }
  const isAlign =
    align_content || flex_direction || align_items || justify_content
      ? true
      : false;

  for (let i = 0; i < uidTable.length; i++) {
    let anims_cnt = 0;
    const uid_anims: Buffer[] = [];
    if (animationTable[i] !== undefined) {
      anims_cnt++;
      const animationUid = getRelateRecordUid(
        animationTable[i],
        recordList
      ) as Buffer;
      uid_anims.push(animationUid);
    }
    dataTable.push(
      ...posTable[i].map((item: any) => (isAlign ? uint16(0) : uint16(item))),
      uidTable[i]
    );
    if (getProtocol() > 8) {
      dataTable.push(uint32(anims_cnt), Buffer.concat(uid_anims));
    }
  }
  const dataBinary = Buffer.concat(dataTable);

  let optionalLength = 0;
  let optionalAppBuf = Buffer.alloc(0);
  let appId = '0x0';
  if (jumpApp === 'jsApplication' || jumpApp === 'luaApplication' || args) {
    optionalLength += 4;
  }
  if (jumpApp) {
    const index = app_id.findIndex((id) => jumpApp === id.split('@')[0]);

    if (jumpApp === 'wechat' || index == -1) {
      const { fillUpstr: appName, fillUpLength: optionalAppNameLength } =
        makeFillUpOfFour(jumpApp);
      const optionalAppNameLengthBuf = uint32(optionalAppNameLength);
      optionalAppBuf = Buffer.concat([
        optionalAppNameLengthBuf,
        Buffer.from(appName)
      ]);
      optionalLength += optionalAppBuf.length;
      appId = '0x00ff';
    } else {
      appId = app_id[index].split('@')[1];
    }
  }

  if (w && h) {
    optionalLength += 4;
  }
  if (isAlign) {
    optionalLength += 4;
  }
  if (translateGroupTypeUid || minClickZone) {
    /** flag扩展，flags[bit15]为1时，添加4位additional_flag： bit0代表有翻译，bit1代表有ifttt，bit2代表最小点击区域 */
    optionalLength += 4;
    /** 翻译ID flags[bit15]指向的【bit0】为1   */
    if (translateGroupTypeUid) optionalLength += 4;
  }
  if (editBoxRelateUid) {
    optionalLength += 4;
  }
  if (iconRelateUid) {
    optionalLength += 4;
  }
  if (condition) {
    optionalLength += 8;
  }

  const originData = {
    type,
    name,
    isAlign,
    preview: previewRelateUid,
    bg: bgRelateUid,
    icon: iconRelateUid,
    editBox: editBoxRelateUid,
    bgColor,
    posTable,
    uidTable,
    totalLength: WIDGET_PRE_LENGTH + dataBinary.length + optionalLength, // layout底下的widget
    dataTable: dataBinary,
    jumpApp,
    groupType,
    widgetJsUid,
    align_content,
    align_items,
    flex_direction,
    justify_content,
    widgetName,
    w,
    h,
    translateWidgetNameUid,
    translateGroupTypeUid,
    conditionUid,
    gap,
    args: jumpApp === 'alipay' && args
      ? String({ paycode: 1, tapPay: 2 }[args] ?? 0)
      : args,
    appId,
    optionalAppBuf,
    minClickZone
  };
  const uid = genId(type);
  const originRecord = genRecord(
    type,
    name,
    uid,
    curDataAddress,
    originData.totalLength || 0
  );
  return { originData, originRecord };
}
